import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Button,
	Divider,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	IconButton,
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import BaseLoader from '../../../UIWidgets/BaseLoader';

import { withRouter } from 'react-router-dom';

const useStyles = makeStyles(() => ({
	root: {
		height: '100%',
	},
	content: {
		padding: 0,
	},
	image: {
		height: 48,
		width: 48,
	},
	actions: {
		justifyContent: 'flex-end',
	},
}));

const LatestProducts = props => {
	const { className, history, staticContext, ...rest } = props;

	const classes = useStyles();

	const [products, addProducts] = useState([]);

	const [isLoading, setLoading] = useState(false);

	useEffect(() => {
		const fetchProduct = async () => {
			axios
				.get('/products', {
					params: {
						currentPage: 1,
						numberPerPage: 6,
					},
				})
				.then(result => {
					setLoading(false);
					addProducts(result.data.products);
				})
				.catch(error => {
					setLoading(false);
					console.log(error);
				});
		};

		setLoading(true);
		fetchProduct();
	}, []);

	const handleClick = id => {
		// jump to detail page
		history.push(`/products/edit-product/${id}`);
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader subtitle={`${products.length} in total`} title='商品列表' />
			<Divider />

			{isLoading ? (
				<BaseLoader />
			) : (
				<CardContent className={classes.content}>
					<List>
						{products.map((product, i) => (
							<ListItem divider={i < products.length - 1} key={product._id}>
								<ListItemAvatar>
									<img
										alt='Product'
										className={classes.image}
										src={
											(product.thumbnail && product.thumbnail.url) ||
											'/images/undraw_page_not_found_su7k.svg'
										}
									/>
								</ListItemAvatar>
								<ListItemText
									primary={product.name}
									secondary={product.description}
								/>
								<IconButton
									edge='end'
									size='small'
									onClick={() => {
										handleClick(product._id);
									}}
								>
									<MoreVertIcon />
								</IconButton>
							</ListItem>
						))}
					</List>
				</CardContent>
			)}

			<Divider />
			<CardActions className={classes.actions}>
				<Button
					color='primary'
					size='small'
					variant='text'
					onClick={() => {
						history.push('/products');
					}}
				>
					查看全部 <ArrowRightIcon />
				</Button>
			</CardActions>
		</Card>
	);
};

LatestProducts.propTypes = {
	className: PropTypes.string,
};

export default withRouter(LatestProducts);
